import { Badge } from "../../tailwind/badge";
import { getStatusColor } from "../../../pages/whatsapp/utils/contactsUtils";

export default function SegmentFilterBadges({ filters = [] }) {
  const activeFilters = filters.filter((filter) => filter.value);
  if (!activeFilters.length) {
    return <span className="text-sm text-gray-400 dark:text-gray-500">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1 min-w-0">
      {activeFilters.map((filter, index) => {
        const key = `${filter.field}-${filter.value}-${index}`;
        const label = filter.value;
        if (filter.field === "lead_status") {
          return (
            <Badge
              key={key}
              variant="outline"
              title={label}
              className={`font-normal text-[10px] px-2 py-0.5 max-w-[8rem] truncate ${getStatusColor(label)}`}
            >
              {label}
            </Badge>
          );
        }
        return (
          <Badge
            key={key}
            variant="secondary"
            title={label}
            className="font-normal text-[10px] max-w-[8rem] truncate bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-gray-300"
          >
            {label}
          </Badge>
        );
      })}
    </div>
  );
}
